import React, { Component } from 'react';
import { Formik } from 'formik';
import { Button, Checkbox, Dialog, Pane, Text } from 'evergreen-ui';

class OrderStatusCompletedModal extends Component {
    render() {
        return (<Dialog
            shouldCloseOnOverlayClick={false}
            width={500}
            isShown={this.props.open}
            title={"Finalizare comanda"}
            hasFooter={false}
            onCloseComplete={this.props.onClose}
            onClose={this.props.onClose}>

            <Pane>
                <Formik initialValues={{
                    sendEmail: true
                }}
                    enableReinitialize={true}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={(values) => {
                        this.props.confirmOperation(values);
                        this.props.onClose();
                    }}
                >
                    {({ handleChange, handleBlur, handleSubmit, values }) => {
                        return <form onSubmit={handleSubmit}>
                            <Pane marginBottom={16}>
                                <Text>Esti sigur ca vrei sa finalizezi aceasta comanda?</Text>
                            </Pane>

                            <Pane display="flex" marginBottom={16}>
                                <Checkbox 
                                    label="Trimite email de finalizare catre client"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="sendEmail"
                                    checked={values.sendEmail}
                                />
                            </Pane>

                            <Pane borderTop="default" marginTop={16} paddingTop={16}>
                                <Button type="submit" intent="success" marginRight={8}>
                                    Confirmare
                                </Button>
                                <Button type="button" onClick={this.props.onClose}>
                                    Anuleaza
                                </Button>
                            </Pane>
                        </form>
                    }}
                </Formik>
            </Pane>
        </Dialog>)
    }
}

export default OrderStatusCompletedModal;
